module.exports = __webpack_public_path__ + "img/whats-new-14_en.2419df4.jpg";